/**
 * Enrollments Store
 * Zustand store para gestión de enrollments pendientes
 */

import { create } from 'zustand';
import type { Enrollment } from '@/types/enrollment';

interface EnrollmentsState {
  // Data
  enrollments: Enrollment[];
  rejected: Enrollment[];

  // Actions
  setEnrollments: (enrollments: Enrollment[]) => void;
  setRejected: (rejected: Enrollment[]) => void;
  addEnrollment: (enrollment: Enrollment) => void;
  removeEnrollment: (enrollmentId: string) => void;
  clearEnrollments: () => void;
}

export const useEnrollmentsStore = create<EnrollmentsState>((set) => ({
  // Initial state
  enrollments: [],
  rejected: [],

  // Actions
  setEnrollments: (enrollments) => set({ enrollments }),

  setRejected: (rejected) => set({ rejected }),

  addEnrollment: (enrollment) =>
    set((state) => {
      // Avoid duplicates
      const exists = state.enrollments.some((e) => e.enrollmentId === enrollment.enrollmentId);
      if (exists) {
        return state;
      }
      return { enrollments: [...state.enrollments, enrollment] };
    }),

  removeEnrollment: (enrollmentId) =>
    set((state) => ({
      enrollments: state.enrollments.filter((e) => e.enrollmentId !== enrollmentId),
      rejected: state.rejected.filter((e) => e.enrollmentId !== enrollmentId),
    })),

  clearEnrollments: () => set({ enrollments: [], rejected: [] }),
}));
